import accountMsGraphSettingsService from "./Campaigns/services/accountMsGraphSettingsService";
import campaignsDataService from "./Campaigns/services/campaignsDataService";
import domainsDataService from "./Domains/services/domainsDataService";
import videoUploaderService from "./Campaigns/services/videoUploaderService";
import threatDefenceSettingsService from "./Campaigns/services/threatDefenceSettingsService";

export const threatDefenceDataServices = {
  campaigns: campaignsDataService,
  videoUploaderService,
  msGraphSettings: accountMsGraphSettingsService,
  domains: domainsDataService,
  smtpSettings: threatDefenceSettingsService,
};
